import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";
import { appEnv } from "../appEnv";

const firebaseConfig = JSON.parse(atob(appEnv.REACT_APP_FIREBASE_CONFIG));

firebase.initializeApp(firebaseConfig);

export default firebase;
